export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/569373b84d4fa61cda98164451d2ed57.svg";